import React          from 'react';
import { useContext } from 'react';
import usePOST        from 'rest/usePOST';
import useStyles      from './orderCardsPageStyles';

import Alert              from 'components/Alert';
import NavBar             from 'NavBar';
import OrderCardsForm     from './OrderCardsForm';
import Paper              from '@mui/material/Paper';
import ResultNotification from 'components/ResultNotification';

import createRestRequestConfig from 'rest/createRestRequestConfig';

import { AuthContext }   from 'App';
import { FINTECH_PATHS } from 'rest/const';


function OrderCardsPage() {

  const { classes } = useStyles();

  const { userInfo } = useContext(AuthContext);

  const [errorAlert, setErrorAlert]     = React.useState(undefined);
  const [successAlert, setSuccessAlert] = React.useState(undefined);
  const [submitData, setSubmitData]     = React.useState(undefined);

  const axiosCfg = createRestRequestConfig(userInfo.accessToken, true);

  function onRestSuccess(response) {
    const status    = response?.status;
    const isSuccess = status >= 200 && status < 300;
    if (!isSuccess) {
      onRestError(response);
      return;
    }

    setSuccessAlert({
      msgTranslKey:          'success',
      msgTranslSecondaryKey: 'orderAccepted',
      type:                  'success'
    });
    setSubmitData(null);
  }

  function onRestError(errOrResp) {
    console.error("Ordering cards failed", errOrResp);
    setErrorAlert({
      msgTranslKey:          'serverError',
      msgTranslSecondaryKey: 'orderNotSent',
      type:                  'error'
    });
    setSubmitData(null);  //to prevent resending them on rerender
  }

  const swrOptions = {
    shouldRetryOnError: false,
    onSuccess:          onRestSuccess,
    onError:            onRestError
  }
  const path       = submitData ? FINTECH_PATHS.orderCards : null;

  const { isValidating, mutate } = usePOST(path, submitData, axiosCfg, swrOptions);

  function handleSubmit(data) {
    setSubmitData(data);
    mutate();
  }

  function reset() {
    setErrorAlert(null);
    setSuccessAlert(null);
    setSubmitData(null);
  }

  //form is hidden instead being removed in order to preserve its state
  return (
    <>
      <NavBar/>
      <Paper elevation={3} className={classes.paper}>
        <div hidden={successAlert != null}>
          <OrderCardsForm onSubmit={handleSubmit} disabled={isValidating}/>
          <Alert alert={errorAlert} setAlert={setErrorAlert}/>
        </div>
        <ResultNotification
          alert={successAlert}
          reset={reset}
        />
      </Paper>
    </>
  );
}

export default OrderCardsPage;